import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import style from '../css/Completed.module.css'; // reuse your styling
import BottomTab from './BottomTab';
import HeaderBar from '../components/HeaderBar';
import { FaSpinner } from 'react-icons/fa';

const Completed = () => {
	const [bookings, setBookings] = useState([]);
	const [loading, setLoading] = useState(true);
	const [refreshing, setRefreshing] = useState(false);
	const [error, setError] = useState('');
	const [selectedTab, setSelectedTab] = useState('All'); // New: tab switcher

	const navigate = useNavigate();

	const fetchAgentID = async () => {
		try {
			return localStorage.getItem('user_id');
		} catch (error) {
			console.error('Failed to get user ID', error);
			return null;
		}
	};

	const fetchBookings = async () => {
		setLoading(true);
		const agentID = await fetchAgentID();
		if (!agentID) return;

		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/fetch_completed_bookings.php?agent_id=${agentID}`
			);
			const result = await response.json();
			if (result.status) {
				setBookings([...result.data].reverse());
			} else {
				setBookings([]);
				setError('Info: ' + result.msg);
			}
		} catch (error) {
			setError('Error: Failed to fetch bookings');
		} finally {
			setLoading(false);
			setRefreshing(false);
		}
	};

	const handleRefresh = useCallback(() => {
		setRefreshing(true);
		fetchBookings();
	}, []);

	const sendFeedbackMail = async (orderNumber, email) => {
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/send_feedback_mail.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ order_number: orderNumber, email }),
				}
			);
			const result = await response.json();
			setError(result.msg);
		} catch (error) {
			setError('Error: Failed to send feedback email.');
		}
	};

	useEffect(() => {
		fetchBookings();
	}, []);

	const filteredBookings = bookings.filter((b) => {
		if (selectedTab === 'Completed') return b.status === 'Completed';
		if (selectedTab === 'Cancelled') return b.status === 'Cancelled';
		if (selectedTab === 'Others')
			return b.status !== 'Completed' && b.status !== 'Cancelled';
		return true; // 'All'
	});

	return (
		<div className={style.container}>
			<HeaderBar title="Bookings" />
				<button className={style.refreshButton} onClick={handleRefresh}>
					<FaSpinner size={18} />
				</button>
			<div className={style.tabContainer}>
				{['All', 'Completed', 'Cancelled', 'Others'].map((tab) => (
					<button
						key={tab}
						onClick={() => setSelectedTab(tab)}
						className={`${style.tabButton} ${
							selectedTab === tab ? style.activeTab : ''
						}`}
					>
						{tab}
					</button>
				))}
			</div>

			{loading ? (
				<div className={style.loader}>Loading...</div>
			) : (
				<div>
					<p>{error}</p>
					{filteredBookings.length > 0 ? (
						filteredBookings.map((item) => (
							<div key={item.order_number} className={style.card}>
								<p className={style.date}>
									{new Date(item.date).toLocaleDateString('en-GB')}
								</p>
								<h3 className={style.orderNumber}>
									Order #: {item.order_number}
								</h3>
								<p className={style.status}>{item.status}</p>

								<div className={style.details}>
									<h4>Customer Details</h4>
									<p>{item.name}</p>
									<p>{item.phone}</p>
									<p>{item.email}</p>
									<p>{item.service}</p>
									<p>{item.location}</p>
									<p>{item.message}</p>
								</div>

								<div className={style.actions}>
									<button
										className={style.invoiceButton}
										onClick={() => navigate(`/invoices/${item.order_number}`)}
									>
										View Invoice
									</button>
									{item.status === 'Completed' && (
										<button
											className={style.feedbackButton}
											onClick={() =>
												sendFeedbackMail(item.order_number, item.email)
											}
										>
											Send Feedback Mail
										</button>
									)}
								</div>
							</div>
						))
					) : (
						<p className={style.noData}>No bookings available.</p>
					)}
				</div>
			)}

			<BottomTab />
		</div>
	);
};

export default Completed;
